import { useEffect, useMemo } from "react";
import { ContentWidth, TextAndImageContent, TextAndImageLayout } from "../..";
import { Api } from "../../../core";

type Props = {
  content: TextAndImageContent;
};

/**
 * Display a preview of the text and image content.
 */
export const TextAndImageContentView = (props: Props) => {
  useEffect(() => {}, []);

  const layoutClass =
    props.content.layout === TextAndImageLayout.IMAGE_LEFT
      ? "image-left"
      : "image-right";

  const widthClass = useMemo(() => {
    switch (props.content.width) {
      case undefined:
        return "content-area";
      case ContentWidth.CONTENT_WIDTH:
        return "content-area";
      case ContentWidth.TEXT_WIDTH:
        return "text-content";
      case ContentWidth.WINDOW_WIDTH:
        return "window-width";
    }
  }, [props.content.width]);

  return (
    <div className={widthClass + " text-and-image " + layoutClass}>
      <div className={"image"}>
        <img
          className="fluid"
          src={Api.getHost() + props.content.filePath}
          alt={props.content.altText}
        />
      </div>
      <div className={"text"}>
        <div dangerouslySetInnerHTML={{ __html: props.content.html }}></div>
      </div>
    </div>
  );
};
